import React, { Component } from "react";
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { getBookInfo } from "../modules/reducers";
import { connect } from "react-redux";
import { withRouter, NavLink } from 'react-router-dom';
import { compose } from "redux";
import swal from "sweetalert";
import Loader from "../components/common/loader";

class StudyMaterial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            slice: [],
            perPage: 10,
            currentPage: 0,
            editableRow: null,
            cname: "",
            id: "",
            chapters: [],
            isLoading: false,
            loadingText: 'Loading...',
        }
    }

    async receivedData() {
        let bid = this.props.history.location.state ? this.props.history.location.state.bid : this.props.book._id;
        // let studyMaterial = [];
        await axios.post(`${BASEURL}/api/v1/studyMaterial/fetchByBook`, { bid: bid })
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    // studyMaterial = res.data;
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].studyMaterialId) {
                            res.data[i].id = res.data[i].studyMaterialId;
                            res.data[i].editableRow = true;
                            res.data[i].youtubeLink = res.data[i].youtubeLink ? res.data[i].youtubeLink : '';
                            res.data[i].ebookLink = res.data[i].ebookLink ? res.data[i].ebookLink : '';
                        } else {
                            res.data[i].editableRow = false;
                            res.data[i].youtubeLink = '';
                            res.data[i].ebookLink = '';
                            res.data[i].pdfFile = {};
                        }
                    }
                    this.setState({
                        chapters: res.data
                    })
                }
            })
            .catch(err => { console.log('fetch studymaterial by book', err) })

    }

    componentDidMount() {
        this.receivedData()
    }

    handleChange = (e, idx) => {
        let chapters = this.state.chapters;
        chapters[idx][e.target.name] = e.target.value
        this.setState({
            chapters
        })
    }

    handleChangeFile = (files, idx) => {
        let chapters = this.state.chapters;
        let value;
        for (let i in files) {
            if (i !== "length" && i !== "item") {
                value = files[i];
                // console.log('value', value)
            }
        }
        chapters[idx]['pdfFile'] = value;

        this.setState({
            chapters,
        });
    };

    handleOnEdit(idx) {
        let chapters = this.state.chapters;
        chapters[idx]['editableRow'] = false;
        this.setState({
            chapters,
        });
    }

    handleOnSave(idx) {
        let chapters = this.state.chapters;
        console.log('chapters[idx]', chapters[idx])
        let form_data = new FormData();
        form_data.append('bid', chapters[idx].bid);
        form_data.append('cid', chapters[idx].cid);
        form_data.append('cname', chapters[idx].cname);
        form_data.append('ebookLink', chapters[idx].ebookLink);
        form_data.append('id', chapters[idx].id);
        form_data.append('youtubeLink', chapters[idx].youtubeLink);
        if (chapters[idx].pdfFile && chapters[idx].pdfFile.name) {
            form_data.append('pdfFile', chapters[idx].pdfFile);
            form_data.append('pdfOldFileKey', chapters[idx].pdfFileKey);
        } else {
            form_data.append('pdfFileKey', chapters[idx].pdfFileKey);
        }
        this.setState({ isLoading: true, loadingText: 'Please wait uploading the data.....' })
        axios.put(`${BASEURL}/api/v1/studyMaterial/update`, form_data)
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    swal("Success", "Data updated successfully", "success")
                        .then(function () {
                            window.location = "studyMaterial";
                        });
                }
            })
            .catch(err => {
                swal("Error", `Error occured While Uploading ${err.message}`, 'error');
                console.log('update study material err', err) 
            })
            .finally(() => {
                this.setState({ isLoading: false, loadingText: '' })
            })
    }

    handleSubmit() {
        console.log('chapters', this.state.chapters);
        let chapters = this.state.chapters;
        let studyMaterial = [];
        let form_data = new FormData();
        for (let i = 0; i < chapters.length; i++) {
            if (chapters[i].pdfFile && chapters[i].pdfFile.name) {
                form_data.append('pdfFile' + i, chapters[i].pdfFile);
            }
            if (!chapters[i].studyMaterialId) {
                if(chapters[i].youtubeLink !== '' || chapters[i].ebookLink) {
                    studyMaterial.push(chapters[i]);
                }
            }
        }
        if(studyMaterial.length === 0) {
            swal("Error", "There is no new data to create", "error");
        } else {
            form_data.append('studyMaterial', JSON.stringify(studyMaterial));
            for (var key of form_data.entries()) {
                console.log(key[0] + ", " + key[1]);
            }
    
            // swal({
            //     text: 'Please wait uploading the data.....',
            //     button: {
            //         visible: false
            //     },
            //     closeOnClickOutside: false,
            //     closeOnEsc: false
            // })
            this.setState({ isLoading: true, loadingText: 'Please wait uploading the data.....' })
            let url = `${BASEURL}/api/v1/studyMaterial`
            axios.post(url, form_data, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(res => {
                    if (res.status === 200) {
                        console.log(res.data);
                        swal("Success", "Data added successfully", "success")
                            .then(function () {
                                window.location = "chapters";
                            });
                    } else if (res.status === 400) {
                        console.log(res.data);
                    }
                }).catch(err => {
                    swal("Error", `Error occured While Uploading ${err.message}`, 'error');
                    console.log(err)
                }).finally(() => {
                    this.setState({ isLoading: false, loadingText: '' })
                })
        }
    }


    render() {
        return (

            <div id="wrapper">
                {this.state.isLoading && <Loader type="progressBar" loadingText={this.state.loadingText} />}
                <Sidebar act="books" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Study Material" breadcrumbItems={['Test Generator', { label: 'Books', path: '/books' }, { label: 'Chapters', path: '/chapters' }, 'Study Material']} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <h4 className="page-title">Book name: {this.props.book.name}</h4>
                                            <table className="table table-centered mb-0 mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Chapter Name</th>
                                                        <th>Youtube Link</th>
                                                        <th>ebook Link</th>
                                                        <th>PDF</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.chapters.length === 0 ?
                                                        <tr className="text-center"><td colSpan="4">No chapters added</td></tr> :
                                                        <>
                                                            {this.state.chapters.map((data, idx) => (
                                                                <tr>
                                                                    <td className="table-user">
                                                                        <input type="text" id="chaptername" className="form-control"
                                                                            name="cname" placeholder="Enter Chapter Name"
                                                                            value={data.cname} disabled />
                                                                    </td>
                                                                    <td className="table-user">
                                                                        <input type="text" id="youtubeLink" className="form-control" onChange={(e) => this.handleChange(e, idx)}
                                                                            name="youtubeLink" value={data.youtubeLink} placeholder="Enter Youtube Link" disabled={data.editableRow} />
                                                                    </td>
                                                                    <td className="table-user">
                                                                        <input type="text" id="ebookLink" className="form-control" onChange={(e) => this.handleChange(e, idx)}
                                                                            name="ebookLink" value={data.ebookLink} placeholder="Enter ebook Link" disabled={data.editableRow} />
                                                                    </td>
                                                                    <td className="table-user">
                                                                        {data.editableRow ?
                                                                            <p>{data.pdfFileKey ? data.pdfFileKey.split('/').pop() : 'No file added'}</p> :
                                                                            <input type="file" id="pdfFile" className="form-control" onChange={(e) => this.handleChangeFile(e.target.files, idx)}
                                                                                name="pdfFile" placeholder="Upload PDF files" accept=".pdf"/>
                                                                        }
                                                                    </td>
                                                                    <td >
                                                                        {data.editableRow ?
                                                                            <button className="btn table_Action_btns"
                                                                                onClick={() => this.handleOnEdit(idx)}
                                                                            > <i className="mdi mdi-pencil" /></button>
                                                                            :
                                                                            <>{data.studyMaterialId ?
                                                                                <button className="btn btn-primary table_Action_btns"
                                                                                    onClick={() => this.handleOnSave(idx)}
                                                                                > <i className="mdi mdi-content-save-outline" />Save</button> : ''}
                                                                            </>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    }
                                                </tbody>
                                            </table>
                                            <button type="submit" class="btn btn-customprimary mt-2" onClick={() => this.handleSubmit()}>Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        book: getBookInfo(state)
    }
}

// const mapDispatchToProps = dispatch => ({
//     getChapter: (cid) => dispatch(getChapterInfo(cid)),
// });

export default compose(withRouter, connect(mapStateToProps))(StudyMaterial);